import { useState } from 'react';
import { getCurrentUser } from '@/lib/supabase';

// Move imports to the top - STATIC imports
import { 
  getTrackedPrograms, 
  addTrackedProgram, 
  deleteTrackedProgram 
} from '@/lib/database/tracked-programs-helpers';

export default function TestHelpers() {
  const [results, setResults] = useState('');
  const [loading, setLoading] = useState(false);

  const runTests = async () => {
    setLoading(true);
    setResults('Running tests...\n');
    
    try {
      const user = await getCurrentUser();
      if (!user) {
        setResults('❌ No user logged in');
        setLoading(false);
        return;
      }
      
      const userId = user.id;
      console.log('Testing with user ID:', userId);
      
      // Test 1: Get existing programs
      console.log('Test 1: Fetching programs...');
      const programs = await getTrackedPrograms(userId);
      console.log('Existing programs:', programs);
      setResults(prev => prev + `✅ Test 1: Found ${programs.length} existing programs\n`);

      // Test 2: Add a test program
      console.log('Test 2: Adding program...');
      const newProgram = await addTrackedProgram(userId, {
        program_type: 'test_camp',
        status: 'considering',
        year_tracked: 2025,
        child_names: ['Test Child'],
        program_data: { test: true }
      });
      console.log('Created program:', newProgram);
      setResults(prev => prev + `✅ Test 2: Created program with ID: ${newProgram.id}\n`);

      // Test 3: Verify it's in the list
      console.log('Test 3: Verifying...');
      const updatedPrograms = await getTrackedPrograms(userId);
      console.log('Updated programs:', updatedPrograms);
      setResults(prev => prev + `✅ Test 3: Now have ${updatedPrograms.length} programs\n`);

      // Test 4: Delete the test program
      console.log('Test 4: Deleting test program...');
      await deleteTrackedProgram(userId, newProgram.id);
      setResults(prev => prev + `✅ Test 4: Deleted test program\n`);

      // Test 5: Verify deletion
      console.log('Test 5: Verifying deletion...');
      const finalPrograms = await getTrackedPrograms(userId);
      setResults(prev => prev + `✅ Test 5: Back to ${finalPrograms.length} programs\n`);
      
      setResults(prev => prev + `\n🎉 All tests passed!`);
    } catch (error) {
      console.error('Test failed:', error);
      setResults(prev => prev + `\n❌ Error: ${error.message}\n${error.stack}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px' }}>
      <h1>Helper Functions Test</h1>
      <button 
        onClick={runTests} 
        disabled={loading}
        style={{ 
          padding: '10px 20px', 
          fontSize: '16px',
          cursor: loading ? 'not-allowed' : 'pointer'
        }}
      >
        {loading ? 'Running Tests...' : 'Run Tests'}
      </button>
      <pre style={{ 
        background: '#f5f5f5', 
        padding: '20px', 
        marginTop: '20px',
        borderRadius: '4px',
        whiteSpace: 'pre-wrap',
        fontFamily: 'monospace'
      }}>
        {results || 'Click "Run Tests" to begin'}
      </pre>
    </div>
  );
}
